import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette, typography, breakpoints }) => ({
  banner: {
    position: 'fixed',
    bottom: '0px',
    right: '0px',
    width: '100vw',
    height: '40vh',
    minHeight: '370px',
    backgroundColor: palette.primary.main,
    borderRadius: '2rem 2rem 0 0',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: spacing(5),
    color: palette.common.white,
    [breakpoints.down('md')]: {
      padding: spacing(3),
      height: '65vh',
      minHeight: '500px',
      flexDirection: 'column',
      justifyContent: 'start',
      '@media (orientation: landscape)': {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        minHeight: '0px'
      }
    }
  },
  mtLogoBackground: {
    position: 'absolute',
    top: '-5vh',
    right: '-5vw',
    height: '45vh',
    width: '50vw',
    minHeight: '400px',
    zIndex: -1,
    [breakpoints.down('lg')]: {
      '@media (orientation: landscape)': {
        right: '-5vw',
        width: '50vw',
        height: '100%'
      }
    },
    [breakpoints.down('md')]: {
      top: '0',
      right: '0',
      width: '150%',
      height: '100%',
      '@media (orientation: landscape)': {
        right: '-5vw',
        width: '50vw',
        height: '100%'
      }
    }
  },
  cta: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '340px',
    [breakpoints.down('md')]: {
      minWidth: '100%',
      alignItems: 'center',
      textAlign: 'center',
      '@media (orientation: landscape)': {
        alignItems: 'start',
        textAlign: 'left',
        minWidth: '50%'
      }
    }
  },
  ctaTitle: {
    width: '75%',
    marginBottom: spacing(2.5),
    [breakpoints.down('lg')]: {
      minWidth: '80%%',
      fontSize: '1.75rem',
      marginBottom: spacing(1.5)
    },
    [breakpoints.down('md')]: {
      minWidth: '100%',
      fontWeight: 500,
      fontSize: '2rem',
      '@media (orientation: landscape)': {
        fontSize: '1.4rem'
      }
    }
  },
  ctaPrice: {
    fontSize: '1.5rem',
    fontWeight: 400,
    marginBottom: spacing(3)
  },
  ctaPriceMobile: {
    marginBottom: spacing(3),
    '@media (orientation: landscape)': {
      fontSize: '1.2rem',
      marginBottom: spacing(1.5)
    }
  },
  ctaSignIn: {
    fontSize: '1.2rem',
    marginTop: spacing(3),
    [breakpoints.down('md')]: {
      marginTop: spacing(1),
      '@media (orientation: landscape)': {
        fontSize: '1rem'
      }
    }
  },
  ctaLink: {
    color: palette.common.white
  },
  ctaButton: {
    backgroundColor: palette.common.black,
    color: palette.primary.white,
    fontWeight: typography.fontWeightBold,
    padding: spacing(1, 4),
    borderRadius: '8px',
    textDecoration: 'none',
    minWidth: '200px',
    minHeight: '50px',
    [breakpoints.down('md')]: {
      minWidth: '300px'
    }
  },
  trust: {
    [breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: spacing(3)
    }
  },
  partners: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    gap: spacing(2),
    marginBottom: spacing(6)
  },
  payment: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(2),
    gap: spacing(4),
    textAlign: 'right',
    [breakpoints.down('md')]: {
      flexDirection: 'column',
      textAlign: 'center',
      gap: spacing(1),
      marginBottom: spacing(2.5)
    }
  },
  paymentDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  paymentOptions: {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(2)
  },
  paymentLogo: {
    backgroundColor: palette.grey[200],
    borderRadius: spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px',
    width: '57px'
  },
  policies: {
    textAlign: 'right',
    fontSize: '0.875rem',
    [breakpoints.down('md')]: {
      textAlign: 'center'
    }
  }
}))
